/**
 * Copy for the blog index. Posts themselves are written on the site at /write
 * and live in the server's blog database, not in the repo (see docs/blog.md).
 */
export const blogMeta = {
  title: "Blog",
  intro: "Notes on software, side projects, and life.",
};
